import React, { useState, useEffect } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import DefaultProfilePic from '../../../Images/BitBlue-Person-Default-Profile-Picture.png';
import { Link } from 'react-router';
import styles from './TopCard.module.css';

function TopCard(props) {
    const { setShowForm, vcardObj, profile_theme, permissions, skillsArr, jobs, resume_link, show_resume} = props;
    const { name_first, name_last, bio, tagline, skills, job_title, organization_name, location, profile_pic } = vcardObj;

    const [ background, setBackground ] = useState(null);

    const noPermissions = useState(
        (permissions.edit_address === false) && 
        (permissions.edit_bio === false) &&
        (permissions.edit_job_title === false) &&
        (permissions.edit_name === false) &&
        (permissions.edit_organization === false) &&
        (permissions.edit_tagline === false) &&
        (permissions.edit_skills) === false
    );
    
    useEffect(() => {
        const profilePicSwitch = () => {
            if (profile_pic) {
                return (
                    <>
                        <img src={`${profile_pic}?${Date.now()}`} alt='profile' height='100%' width='100%'></img>
                        {permissions.edit_profile_pic && <div className={styles.editImage}>Edit</div>}
                    </>
                );
            } else {
                return (
                    <>
                        <img src={DefaultProfilePic} alt='default-profile' height='100%' width='100%'></img>
                        {permissions.edit_profile_pic && <div className={styles.editImage}>Edit</div>}
                    </>
                );
            };
        };
        
        const handleBackgroundJSX = () => {
            if (profile_theme.background?.includes(".mp4")){
                setBackground(
                    <div className={styles.bgWrapper}>
                        <div className={styles.bgContainer}>
                            <video src={`${profile_theme.background}?${Date.now()}`} autoPlay playsInline loop muted className={styles.videoBg} style={{zIndex: '5'}} />
                            <div className={styles.videoBgBlurWrapper}>
                                <video src={`${profile_theme.background}?${Date.now()}`} autoPlay playsInline loop muted className={styles.videoBgBlur} />
                            </div>
                            <div className={profile_pic ? `${styles.profilePicWrapper}` : `${styles.profilePicWrapperNone}`} style={{borderColor: profile_theme.profile_img_border, cursor: (permissions.edit_profile_pic ? 'pointer' : 'default')}} onClick={permissions.edit_profile_pic ? () => setShowForm("edit-profile-image") : e => e.preventDefault()}>
                                {profilePicSwitch()}
                            </div>
                        </div>
                        <Link to='/settings/themes' className={styles.bgBtn}><i className='far fa-edit' /></Link>
                    </div>
                );
            } else {
                setBackground(
                    <div className={styles.bgWrapper}>
                        <div className={styles.bgContainer}>
                            <img src={`${profile_theme.background}?${Date.now()}`} alt='Top Card Background' className={styles.bgImage}></img>
                            <div className={profile_pic ? `${styles.profilePicWrapper}` : `${styles.profilePicWrapperNone}`} style={{borderColor: profile_theme.profile_img_border, cursor: (permissions.edit_profile_pic ? 'pointer' : 'default')}} onClick={permissions.edit_profile_pic ? () => setShowForm("edit-profile-image") : e => e.preventDefault()}>
                                {profilePicSwitch()}
                            </div>
                        </div>
                        <Link to='/settings/themes' className={styles.bgBtn}><i className='far fa-edit' /></Link>
                    </div>
                );
            }
        };

        if (!background) {
            handleBackgroundJSX();
        };
    },[profile_theme, background, permissions?.edit_profile_pic, profile_pic]);

    return (
        <div className={styles.card} style={{background: profile_theme.top_card_color}}>
            {background}
            <div className={styles.cardInfo} onClick={() => setShowForm("edit-top-card")} style={!noPermissions ? {cursor: 'default', fontFamily: profile_theme.font} : {cursor: 'pointer', fontFamily: profile_theme.font}}>
                {(name_first || name_last) &&
                    <h3 className={styles.name} style={{color: profile_theme.top_text_color}}>{name_first && name_first} {name_last && name_last}{!noPermissions ? null : <i className='far fa-edit ms-2'/>}</h3> 
                }
                {(tagline) &&
                    <h5 className={styles.tagline} style={{color: profile_theme.top_text_color}}>
                        {tagline}
                    </h5>
                }
                <div className={styles.cardInfoInner}>
                    {(job_title || organization_name) &&
                        <p style={{color: profile_theme.top_text_color}}>
                            {(job_title && organization_name) ? 
                                `${job_title} at ${organization_name}` 
                            : (job_title && !organization_name) ? 
                                job_title 
                            : organization_name}
                        </p>
                    }   
                    {location &&
                        <p style={{color: profile_theme.top_text_color}}>
                            {location}
                        </p>
                    }     
                </div>
            </div>
            {(bio || (skills && skillsArr?.length > 0) || (jobs && resume_link && show_resume)) &&
                <Accordion className={styles.information} style={{fontFamily: profile_theme.font}}> 
                    <Accordion.Item eventKey='0'>
                        <Accordion.Header>
                            <i className='fas fa-grip-dots mx-5' style={{color: profile_theme.top_text_color}} />
                        </Accordion.Header>
                        <Accordion.Body style={(!bio || !skills) ? {color: profile_theme.top_text_color, height: '6rem'} : {color: profile_theme.top_text_color}}>
                            {bio &&
                                <>
                                <h5 style={{textDecoration: 'underline'}}>About Me</h5>
                                <div className={styles.bio} style={(jobs && resume_link && show_resume) ? {width: '75%'} : {width: '100%'}}>{bio}</div>
                                </>
                            }
                            {(skills && skillsArr?.length > 0) &&
                                <>
                                <h5 style={{textDecoration: 'underline'}}>Interests/Skills</h5>
                                <div className={styles.skills} style={(!bio && jobs && resume_link && show_resume) ? {width: '75%'} : {width: '100%'}}>
                                    {skillsArr.map((skill,index) => (
                                        <p className={styles.skill} style={{background: profile_theme.btn_color, color: profile_theme.btm_text_color}} key={index}>{skill}</p>
                                    ))
                                    }
                                </div>
                                </>  
                            }
                            {(jobs && resume_link && show_resume) ? 
                                <div className={styles.resumeBtn} style={(!bio && !skills) ? {background: profile_theme.btn_color, left: 'calc(50% - 2.5rem)', right: 'none'} : {background: profile_theme.btn_color}}> 
                                    <i className='far fa-file-user' style={{color: profile_theme.btm_text_color}}></i>                           
                                    <div className={styles.word}style={{color: profile_theme.btm_text_color}}>Resume</div>
                                </div>
                                : <></>
                            }
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            }
        </div>
    );
};

export default TopCard;